module.exports = __webpack_public_path__ + "img/img9.96498baa.png";